import React, {Fragment} from 'react'
import Header from '../components/Header'
import Hero from '../components/Hemundervisning/Hero'
import VideoSection from '../components/Hemundervisning/VideoSection'
import Quiz from '../components/Hemundervisning/Quiz'
import Content from '../components/Hemundervisning/Content'
import CTA from '../components/Hemundervisning/CTA'
import Footer from '../components/Footer'
import {Link} from 'gatsby'


class Hemundervisning extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            device: 'desktop',
        }
    }
    
    render(){
        return(
            <Fragment>
                <Header logoColor="#ffffff" classStatic="juniorHeader header-cvd" dropDownColor="black" page='senior'  title="Albert"/>
                <Hero />
                <VideoSection />
                <Quiz />
                {/* <Content /> */}
                <CTA />
                <Footer />
            </Fragment>
        )
    }
}

export default Hemundervisning;